import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useToasts } from "react-toast-notifications";
import { useEffect, useState, useCallback } from "react";
import Select from 'react-select';
import AsyncSelect, { makeAsyncSelect } from 'react-select/async';
import "../../styles.css";
import { debounce } from "lodash";
import { asyncDebouncer } from '../../utils/helper';
import Avatar from "../../common/Avatar";

const customStyles = {
    menuList: (provided, state) => ({
        ...provided,
        textAlign: 'left'
    }),
};

const initialState = {
    pu: null,
    ru: null,
    percent: 0,
    status: 0,
    ru2: null,
    percent2: 0,
    status2: 0
};

const ReferralModal = (props) => {
    const { addToast } = useToasts();

    const [referralForm, setReferralForm] = useState(initialState);
    const {
        users,
        params,
        tableAction,
        showModal,
        setShowModal,
        setUpdateReferral,
        getReferrals
    } = props;

    const [isBusy, setIsBusy] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (params) {
            console.log({ params });
            setReferralForm({
                ...referralForm,
                id: params.id,
                pu: {
                    login: params.pu?.login || null,
                    id: params.pu?.id || null,
                    pu_commissionrate: params.pu?.creator.pu_commissionrate || null
                },
                ru: {
                    login: params.ru1?.login,
                    id: params.ru1?.id
                },
                ru2: {
                    login: params.ru2?.login,
                    id: params.ru2?.id
                },
                status: params.status,
                status2: params.status2,
                percent: params.percent,
                percent2: params.percent2
            });
        } else {
            setReferralForm(initialState);
        }
    }, [params]);

    const handleSave = async () => {
        const params = {
            id: referralForm.id || null,
            pu: referralForm.pu?.id || null,
            ru: referralForm.ru?.id || null,
            ru2: referralForm.ru2?.id || null,
            status: parseFloat(referralForm.percent) > 0,
            status2: parseFloat(referralForm.percent2) > 0,
            percent: referralForm.percent,
            percent2: referralForm.percent2,
            pu_commissionrate: referralForm.pu && referralForm.pu.pu_commissionrate ? referralForm.pu.pu_commissionrate : ''
        };
        setIsBusy(true);
        setErrors({});
        await axios.post(`/api/administration/referral/${tableAction}`, params)
            .then((response) => {
                const data = response.data;
                setShowModal(false);
                setUpdateReferral(true);
                addToast(data.message, { appearance: 'success', autoDismiss: true });
                setIsBusy(false);
                getReferrals();
            })
            .catch((error) => {
                console.log(error.response);
                setUpdateReferral(false);
                setIsBusy(false);

                if (error.response.status === 422) {
                    let tmp = {};
                    Object.keys(error.response.data.errors).forEach((key) => {
                        tmp[key] = error.response.data.errors[key][0];
                    });

                    setErrors(tmp);
                }
            });
    };

    const handleSelect = (key, value) => {
        console.log({ key, value });

        setReferralForm({
            ...referralForm,
            [key]: {
                login: value.login,
                id: value.id,
                pu_commissionrate: value.pu_commissionrate
            }
        });
    };

    const [puOptions, setPuOptions] = useState([]);
    const handlePuOptions = (users, inputValue) => {
        const newUsers = users.map(user => {
            const list = {};
            list.id = user.id;
            list.login = user.login;
            list.pu_commissionrate = user.creator?.pu_commissionrate || null;
            return list;
        });
        return newUsers.filter(user =>
            user.login.toLowerCase().includes(inputValue.toLowerCase())
        );
    };
    const handlePuChange = asyncDebouncer(async (inputValue) => {
        const response = await axios.get('/api/users', {
            params: {
                login: inputValue
            }
        });

        return handlePuOptions(response.data, inputValue);
    }, 800);

    const handleClear = (key) => {
        setReferralForm({
            ...referralForm,
            [key]: ''
        });
        setErrors({});
    };

    useEffect(() => {
        if (showModal) {
            setErrors({});
        }
    }, [showModal]);

    return (
        <Modal size="lg" className="alert-confirm-modal" centered show={showModal} onHide={() => setShowModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {/* {tableAction ==='add' ? 'Add New' : 'Edit'} Referral */}
                    Add/Edit Referral - Commission
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-5">
                <div className="row mb-4">
                    <div className="col-md-1">
                        Creator
                    </div>
                    <div className="col-md-1 my-1">
                        <Avatar pu={params?.pu || {}} story={false} size="32" />
                    </div>
                    <div className="col-md-5">
                        <AsyncSelect
                            loadOptions={handlePuChange}
                            cacheOptions
                            getOptionLabel={(option) => option.login}
                            getOptionValue={(option) => option.id}
                            placeholder="Select PU"
                            styles={customStyles}
                            noOptionsMessage={() => "Type to search PU"}
                            onChange={(value, triggeredAction) => {
                                if (triggeredAction.action === 'clear') {
                                    handleClear('pu');
                                } else {
                                    handleSelect('pu', value);
                                }
                            }}
                            value={referralForm.pu}
                            isClearable
                        />
                        {errors.pu && <div className="text-danger">{errors.pu}</div>}
                    </div>
                    <div className="col-md-2">
                        Commission (%)
                    </div>
                    <div className="col-md-3">
                        <input
                            type="number"
                            min="0"
                            value={referralForm.pu && referralForm.pu.pu_commissionrate ? referralForm.pu.pu_commissionrate : ''}
                            onChange={(e) => setReferralForm({ ...referralForm, pu: { ...referralForm.pu, pu_commissionrate: e.target.value } })}
                            style={{ textAlign: 'center' }}
                        />
                        {errors.pu_commissionrate && <div className="text-danger">{errors.pu_commissionrate}</div>}
                    </div>
                </div>
                {/* Referrer 1 */}
                <div className="row mb-4">
                    <div className="col-md-1">
                        Referrer 1
                    </div>
                    <div className="col-md-1 my-1">
                        <Avatar pu={params?.ru1 || {}} story={false} size="32" />
                    </div>
                    <div className="col-md-5">
                        <AsyncSelect
                            // onInputChange={handlePuChange}
                            loadOptions={handlePuChange}
                            cacheOptions
                            getOptionLabel={(option) => option.login}
                            getOptionValue={(option) => option.id}
                            placeholder="Select RU"
                            styles={customStyles}
                            noOptionsMessage={() => "Type to search user"}
                            value={referralForm.ru}
                            isClearable
                            onChange={(value, triggeredAction) => {
                                if (triggeredAction.action === 'clear') {
                                    handleClear('ru');
                                } else {
                                    handleSelect('ru', value);
                                }
                            }}
                        />
                        {errors.ru && <div className="text-danger">{errors.ru}</div>}
                    </div>
                    <div className="col-md-2">
                        Percent (%)
                    </div>
                    <div className="col-md-3">
                        <input
                            type="number"
                            value={referralForm.percent}
                            onChange={(e) => setReferralForm({ ...referralForm, percent: e.target.value })}
                            style={{ textAlign: 'center' }}
                        />
                        {errors.percent && <div className="text-danger">{errors.percent}</div>}
                    </div>
                </div>

                {/* Referrer 2 */}
                <div className="row mb-4">
                    <div className="col-md-1">
                        Referrer 2
                    </div>
                    <div className="col-md-1 my-1">
                        {params && params.ru2 && <Avatar pu={params?.ru2 || {}} story={false} size="32" />}
                    </div>
                    <div className="col-md-5">
                        <AsyncSelect
                            loadOptions={handlePuChange}
                            cacheOptions
                            getOptionLabel={(option) => option.login}
                            getOptionValue={(option) => option.id}
                            placeholder="Select RU2"
                            styles={customStyles}
                            noOptionsMessage={() => "Type to search user"}
                            value={referralForm.ru2}
                            isClearable
                            onChange={(value, triggeredAction) => {
                                if (triggeredAction.action === 'clear') {
                                    handleClear('ru2');
                                } else {
                                    handleSelect('ru2', value);
                                }
                            }}
                        />
                        {errors.ru2 && <div className="text-danger">{errors.ru2}</div>}
                    </div>
                    <div className="col-md-2">
                        Percent (%)
                    </div>
                    <div className="col-md-3">
                        <input
                            type="number"
                            value={referralForm.percent2}
                            onChange={(e) => setReferralForm({ ...referralForm, percent2: e.target.value })}
                            style={{ textAlign: 'center' }}
                        />
                        {errors.percent2 && <div className="text-danger">{errors.percent2}</div>}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="alertconfirm-btns">
                    <Button
                        onClick={handleSave}
                        variant="primary"
                        disabled={isBusy}
                    >
                        {isBusy ? 'Saving...' : 'Save'}
                    </Button>
                    <Button onClick={() => setShowModal(false)} variant="primary">Cancel</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ReferralModal;
